// extracted by mini-css-extract-plugin
module.exports = {"root":"LogoutButton_root__xxRgj","icon":"LogoutButton_icon__G7pJ_"};